export function leftAQueries(state) {
  return state.queries.leftA;
}
export function leftBQueries(state) {
  return state.queries.leftB;
}
export function rightAQueries(state) {
  return state.queries.rightA;
}
export function rightBQueries(state) {
  return state.queries.rightB;
}
export function invokeSearch(state) {
  return state.invokeSearch;
}
export function query(state) {
  return state.query;
}
export function leftAQueriesJson(state) {
  return JSON.stringify(state.queries.leftA);
}
export function leftBQueriesJson(state) {
  return JSON.stringify(state.queries.leftB);
}
export function rightAQueriesJson(state) {
  return JSON.stringify(state.queries.rightA);
}
export function rightBQueriesJson(state) {
  return JSON.stringify(state.queries.rightB);
}